const WIDTH = 600
const HEIGHT = 840
const MAX_SIZE = 300 * 1024
const MIME_TYPE = 'image/jpeg'
const MIN_QUALITY = 0.25
const MAX_QUALITY = 0.92

function loadImage(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file)
    const image = new Image()
    image.onload = () => { URL.revokeObjectURL(url); resolve(image) }
    image.onerror = () => { URL.revokeObjectURL(url); reject(new Error('Failed to load cover image')) }
    image.src = url
  })
}

function toBlob(canvas, quality) {
  return new Promise((resolve, reject) => {
    canvas.toBlob(blob => blob ? resolve(blob) : reject(new Error('Failed to compress cover image')), MIME_TYPE, quality)
  })
}

export async function prepareCollectionCover(file) {
  const image = await loadImage(file)
  const canvas = document.createElement('canvas')
  canvas.width = WIDTH
  canvas.height = HEIGHT
  const context = canvas.getContext('2d')
  if (!context) throw new Error('Failed to prepare cover image')

  const targetRatio = WIDTH / HEIGHT
  const sourceRatio = image.width / image.height
  const sourceWidth = sourceRatio > targetRatio ? image.height * targetRatio : image.width
  const sourceHeight = sourceRatio > targetRatio ? image.height : image.width / targetRatio
  const sourceX = (image.width - sourceWidth) / 2
  const sourceY = (image.height - sourceHeight) / 2
  context.fillStyle = '#ffffff'
  context.fillRect(0, 0, WIDTH, HEIGHT)
  context.drawImage(image, sourceX, sourceY, sourceWidth, sourceHeight, 0, 0, WIDTH, HEIGHT)

  let low = MIN_QUALITY
  let high = MAX_QUALITY
  let blob = await toBlob(canvas, high)
  if (blob.size > MAX_SIZE) {
    for (let i = 0; i < 7; i++) {
      const quality = (low + high) / 2
      const candidate = await toBlob(canvas, quality)
      if (candidate.size <= MAX_SIZE) {
        blob = candidate
        low = quality
      } else {
        high = quality
      }
    }
    if (blob.size > MAX_SIZE) blob = await toBlob(canvas, MIN_QUALITY)
    if (blob.size > MAX_SIZE) throw new Error('Unable to compress cover below 300KB')
  }

  const baseName = file.name.replace(/\.[^/.]+$/, '') || 'cover'
  return new File([blob], `${baseName}.jpg`, { type: MIME_TYPE, lastModified: Date.now() })
}
